export default "__VITE_ASSET__fc8e922b__"